/* eslint-disable max-lines-per-function */
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useAnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/useAnlageassistentContext';
import { getTageKeyByValue } from '@/domain/mitarbeiter/features/anlageassistent/utils/constants/tage';
import { Checkbox, Label } from '@e2n/ui';
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

export function Feiertagseinstellungen() {
  const { ctx } = useAnlageassistentContext();
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();
  return (
    <div className="flex flex-col md:gap-10 gap-6">
      <h2 className="text-neutrals-900 text-xl font-bold leading-7 flex items-center gap-1">
        {ctx.getCurrentSubStep()?.title}
      </h2>
      <div className="flex flex-col gap-4">
        <form.AppField name="abwesenheiten.feiertagseinstellungen.zuschlagsregelungGreift">
          {(field) => (
            <div className="flex gap-2 items-center">
              <Checkbox
                id={field.name}
                name={field.name}
                checked={field.state.value}
                onCheckedChange={(e) => field.handleChange(!!e)}
                onBlur={field.handleBlur}
              />
              <Label
                htmlFor={field.name}
                className="text-neutrals-900 text-sm font-normal leading-5">
                {t(
                  'domain.mitarbeiter.create.steps.abwesenheiten.feiertagseinstellungen.form.zuschlagsregelungGreift.label',
                )}
              </Label>
            </div>
          )}
        </form.AppField>
        <form.AppField name="abwesenheiten.feiertagseinstellungen.stundenGutschreibung">
          {(field) => (
            <div className="flex gap-2 items-start">
              <Checkbox
                id={field.name}
                name={field.name}
                checked={field.state.value}
                onCheckedChange={(e) => field.handleChange(!!e)}
                onBlur={field.handleBlur}
              />
              <div className="flex flex-col gap-4 w-full">
                <Label
                  htmlFor={field.name}
                  className="text-neutrals-900 text-sm font-normal leading-5">
                  {t(
                    'domain.mitarbeiter.create.steps.abwesenheiten.feiertagseinstellungen.form.stundenGutschreibung.label',
                  )}
                </Label>
                <form.Subscribe
                  selector={(state) => ({
                    arbeitstage:
                      state.values.bezahlung.arbeitszeitkonto.arbeitstage,
                  })}>
                  {({ arbeitstage }) =>
                    field.state.value &&
                    arbeitstage.length > 0 && (
                      <div className="flex flex-col gap-2 bg-neutrals-200 rounded-xl py-4 px-5">
                        <span className="text-neutrals-900 text-sm font-normal leading-5">
                          {t(
                            'domain.mitarbeiter.create.steps.abwesenheiten.feiertagseinstellungen.form.stundenGutschreibung.info.aufzuwendendeUrlaubstage',
                            { tage: arbeitstage.length },
                          )}
                        </span>
                        <span className="text-neutrals-900 text-sm font-semibold leading-5 flex gap-1 items-center">
                          <FontAwesomeIcon icon={faArrowRight} />
                          {t(
                            'domain.mitarbeiter.create.steps.abwesenheiten.feiertagseinstellungen.form.stundenGutschreibung.info.feiertagsAusgleich',
                            {
                              listTage: [...arbeitstage]
                                .sort((a, b) => a - b)
                                .map((tag) =>
                                  t(
                                    'general.date.days.' +
                                      getTageKeyByValue(tag),
                                  ),
                                )
                                .join(', '),
                            },
                          )}
                        </span>
                      </div>
                    )
                  }
                </form.Subscribe>
              </div>
            </div>
          )}
        </form.AppField>

        <form.AppField name="abwesenheiten.feiertagseinstellungen.taeglicheArbeitszeitAuffuellen">
          {(field) => (
            <div className="flex gap-2 items-center">
              <Checkbox
                id={field.name}
                name={field.name}
                checked={field.state.value}
                onCheckedChange={(e) => field.handleChange(!!e)}
                onBlur={field.handleBlur}
              />
              <Label
                htmlFor={field.name}
                className="text-neutrals-900 text-sm font-normal leading-5">
                {t(
                  'domain.mitarbeiter.create.steps.abwesenheiten.feiertagseinstellungen.form.taeglicheArbeitszeitAuffuellen.label',
                )}
              </Label>
            </div>
          )}
        </form.AppField>
      </div>
    </div>
  );
}
